import { render, staticRenderFns } from "./FantasyMarketClosed.vue?vue&type=template&id=55e3ea44&"
import script from "./FantasyMarketClosed.vue?vue&type=script&lang=js&"
export * from "./FantasyMarketClosed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports